import useRoleNavigate from '@brands/hooks/useRoleNavigate';
import React, { useCallback } from 'react';

import modalClose from '../../../assets/icons/close.svg';
import Check from '../../../Auth/assets/check.svg';
import styles from './dashboardModal.module.scss';

const SubmitConfirmationModal = (): JSX.Element => {
  const roleNavigate = useRoleNavigate();
  const goToDashboard = useCallback(() => {
    roleNavigate('/dashboard');
  }, [roleNavigate]);
  return (
    <div className={styles.modalBackground} onClick={() => goToDashboard()}>
      <div
        className={`${styles.modalContainer} ${styles.submitConfirmationModal} fs-unmask`}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className={styles.modalClose}
          style={{ backgroundImage: `url(${modalClose})` }}
          aria-label="Close modal"
          onClick={() => goToDashboard()}
        />
        <div className={styles.body}>
          <div className={styles.success}>
            <img src={Check} alt="Success" />
          </div>
          <p>
            Thank you! You have successfully submitted everything needed for a Photo Review consultation. A dentist will
            begin working on it shortly and you’ll be notified as soon as it’s ready.
          </p>
        </div>
      </div>
    </div>
  );
};
export default SubmitConfirmationModal;
